module.exports = __webpack_public_path__ + "static/media/027_user_journey_learningpath2-01.a6a8263f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/027_user_journey_learningpath2-01.png
// module id = 406
// module chunks = 0